import { format } from 'date-fns';

/**
 * Date型を yyyy-MM-dd 形式の文字列(ex: 2024-01-01)に変換する。
 * @param date Date
 * @returns string
 */
export function formatDateHypen(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}
